import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import type { BaseModalProps } from '@trinity/chat-components/hooks/useModal.js';

type Props = BaseModalProps & {
  title: string;
  extractedData: unknown;
};

const stripSourceIds = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(stripSourceIds);
  }
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .filter(([key]) => key !== 'source_ids')
        .map(([key, val]) => [key, stripSourceIds(val)])
    );
  }
  return value;
};

export const ExtractedDataJsonModal = ({ open, onClose, title, extractedData }: Props) => {
  const jsonString = JSON.stringify(stripSourceIds(extractedData), null, 2);

  return (
    <Dialog fullWidth maxWidth="md" onClose={onClose} open={open}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <SyntaxHighlighter
          language="json"
          style={oneLight}
          customStyle={{ margin: 0, borderRadius: '6px', fontSize: '13px', maxHeight: '70vh' }}
        >
          {jsonString}
        </SyntaxHighlighter>
      </DialogContent>
    </Dialog>
  );
};

ExtractedDataJsonModal.displayName = 'Transcript.Modal.ExtractedDataJson';
